export enum ScheduleType {
  CONSULTATION = 'C',
  EXAM = 'E',
  SERVICE = 'S',
  SURGERY = 'Y',
  CHEMOTHERAPY = 'Q',
  REQUEST = 'R',
  WAITING_LIST = 'W'
}
